import React from 'react';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AssignmentTurnedIn from '@material-ui/icons/AssignmentTurnedIn';
import BeenhereIcon from '@material-ui/icons/Beenhere';
import BuildIcon from '@material-ui/icons/Build';
import BulbIcon from '@material-ui/icons/EmojiObjects';
import BusinessIcon from '@material-ui/icons/Business';
import CalendarIcon from '@material-ui/icons/CalendarToday';
import CarIcon from '@material-ui/icons/DirectionsCar';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import DashboardIcon from '@material-ui/icons/Dashboard';
import DescriptionIcon from '@material-ui/icons/Description';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import FaceIcon from '@material-ui/icons/Face';
import FormatQuoteIcon from '@material-ui/icons/FormatQuote';
import ForumIcon from '@material-ui/icons/Forum';
import GasIcon from '@material-ui/icons/LocalGasStation';
import GroupIcon from '@material-ui/icons/Group';
import KeyIcon from '@material-ui/icons/VpnKey';
import LinkIcon from '@material-ui/icons/Link';
import ListAltIcon from '@material-ui/icons/ListAlt';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import LocationIcon from '@material-ui/icons/LocationOn';
import LoyaltyIcon from '@material-ui/icons/Loyalty';
import MenuIcon from '@material-ui/icons/Menu';
import MessageIcon from '@material-ui/icons/Message';
import MoneyIcon from '@material-ui/icons/AttachMoney';
import MoreIcon from '@material-ui/icons/MoreVert';
import PeopleIcon from '@material-ui/icons/People';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PersonIcon from '@material-ui/icons/Person';
import PhoneIcon from '@material-ui/icons/PhoneIphone';
import PostAddIcon from '@material-ui/icons/PostAdd';
import RouterIcon from '@material-ui/icons/Router';
import RouterOutlinedIcon from '@material-ui/icons/RouterOutlined';
import ScheduleIcon from '@material-ui/icons/Schedule';
import SearchIcon from '@material-ui/icons/Search';
import SettingsIcon from '@material-ui/icons/Settings';
import StorefrontIcon from '@material-ui/icons/Storefront';
import Subject from '@material-ui/icons/Subject';
import TimerIcon from '@material-ui/icons/Timer';
import TocIcon from '@material-ui/icons/Toc';
import TrainIcon from '@material-ui/icons/Train';
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import Badge from '@material-ui/core/Badge';
import { useTheme } from '@material-ui/core/styles';

const Components = (style) => ({
  AssignmentIcon: <AssignmentIcon style={style} />,
  AssignmentTurnedIn: <AssignmentTurnedIn style={style} />,
  BeenhereIcon: <BeenhereIcon style={style} />,
  BuildIcon: <BuildIcon style={style} />,
  BuildMenuIcon: <BuildIcon style={style} />,
  BulbIcon: <BulbIcon style={style} />,
  BusinessIcon: <BusinessIcon style={style} />,
  CalendarIcon: <CalendarIcon style={style} />,
  CalendarMenuIcon: <CalendarIcon style={style} />,
  CarIcon: <CarIcon style={style} />,
  CheckBoxIcon: <CheckBoxIcon style={style} />,
  CheckCircleIcon: <CheckCircleIcon style={style} />,
  ContactSupportMenuIcon: <FaceIcon style={style} />,
  DashboardIcon: <DashboardIcon style={style} />,
  DescriptionIcon: <DescriptionIcon style={style} />,
  DriveEtaIcon: <DriveEtaIcon style={style} />,
  EmojiTransportationMenuIcon: <EmojiTransportationIcon style={style} />,
  ForumIcon: <ForumIcon style={style} />,
  GasIcon: <GasIcon style={style} />,
  GroupIcon: <GroupIcon style={style} />,
  GroupMenuIcon: <GroupIcon style={style} />,
  KeyIcon: <KeyIcon style={style} />,
  LinkIcon: <LinkIcon style={style} />,
  ListAltMenuIcon: <ListAltIcon style={style} />,
  LocalShippingIcon: <LocalShippingIcon style={style} />,
  LocationIcon: <LocationIcon style={style} />,
  LocationMenuIcon: <LocationIcon style={style} />,
  LoyaltyIcon: <LoyaltyIcon style={style} />,
  MenuIcon: <MenuIcon style={style} />,
  MessageIcon: <MessageIcon style={style} />,
  MoneyIcon: <MoneyIcon style={style} />,
  MoreIcon: <MoreIcon style={style} />,
  PeopleIcon: <PeopleIcon style={style} />,
  PersonAddIcon: <PersonAddIcon style={style} />,
  PersonIcon: <PersonIcon style={style} />,
  PhoneIcon: <PhoneIcon style={style} />,
  PostAddIcon: <PostAddIcon style={style} />,
  QuoteIcon: <FormatQuoteIcon style={style} />,
  RouterIcon: <RouterIcon style={style} />,
  RouterOutlinedIcon: <RouterOutlinedIcon style={style} />,
  ScheduleIcon: <ScheduleIcon style={style} />,
  SearchIcon: <SearchIcon style={style} />,
  SettingsIcon: <SettingsIcon style={style} />,
  StorefrontIcon: <StorefrontIcon style={style} />,
  Subject: <Subject style={style} />,
  TimerIcon: <TimerIcon style={style} />,
  TocMenuIcon: <TocIcon style={style} />,
  TrainIcon: <TrainIcon style={style} />,
  TrendingUpIcon: <TrendingUpIcon style={style} />,
});

const MenuBarIcon = ({ name, style, large, showMessageBadge = false }) => {
  const theme = useTheme();
  const { color } = theme.sidebar;

  if (!name) {
    return null;
  }
  const iconStyle = large
    ? { ...style, paddingRight: '0.8em', display: 'flex', width: '1em' }
    : style;
  const components = Components({ color });
  if (components.hasOwnProperty(name)) {
    if (showMessageBadge) {
      return (
        <Badge style={iconStyle} variant="dot" color="error">
          {components[name]}
        </Badge>
      );
    }
    return <span style={iconStyle}>{components[name]}</span>;
  }
  return null;
};

export default MenuBarIcon;
